/**
 * @prettier
 */

import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/CustomButton";
import DataDogService from "../../../services/shared/datadogService";
import { ACTION_LABELS } from "../../../config/dataDogActionLabels";

function RedirectButton({ redirectUrl }) {
    const { t } = useTranslation();

    if (!redirectUrl) {
        return null;
    }

    const handleClick = () => {
        DataDogService.log(
            "User clicked continue on redirect-blocked fallback, opening return_url."
        );
        window.open(redirectUrl, "_self");
    };

    return (
        <div className="redirect-url-cta-container">
            <div className="redirect-url-cta-container-item">
                <CustomButton
                    type="button"
                    label={t("idpal_continue")}
                    id="redirect-blocked-continue-button"
                    handleClick={handleClick}
                    actionDataLabel={
                        ACTION_LABELS.success.redirectBlockedContinueButton
                    }
                />
            </div>
        </div>
    );
}

export default RedirectButton;
